module.exports = __webpack_public_path__ + "static/img/step3-1.098542d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/step3-1.png
// module id = Nw3i
// module chunks = 1